import React from "react";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import { NewAppBody } from "views/MyApps/NewAppBody";

export function NewAppContent(props) {
  return (
    <GridContainer>
      <GridItem md={2}></GridItem>
      <GridItem md={8}>
        <NewAppBody
          user={props.user}
          registerApp={props.registerApp}
          registerButtonDisabled={props.registerButtonDisabled}
          setRegisterButtonDisabled={props.setRegisterButtonDisabled}
          setCrudState={props.setCrudState}
        />
      </GridItem>
      <GridItem md={2}></GridItem>
    </GridContainer>
  );
}
